<template>
  <div>

    <div class="field">
      <label class="label">{{ label }}</label>
      <div class="control">

        <label class="checkbox">
          <input type="checkbox" :id="id" :name="name" :checked="value == '1'"
            @change="updateField($event.target.checked)">
          {{ placeholder }}
        </label>
      </div>
      <span class="help is-danger" v-if="error" v-text="error"></span>
    </div>

  </div>
</template>
<script>
  export default {
    components: {  
    },
    props: {
      form: {},
      id: {},
      name: {},
      value: {},
      label: {},
      options: {},
      error: {},
      placeholder: {}
    },
    data() {
      return {
      }
    },
    methods: {
      updateField(value) {
        this.$emit('input', value);
      }
    }
  }
</script>
<style scoped lang="scss">
  .field {
    margin-bottom: 1em;
  }
</style>


// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/form/elements/CheckboxGroup.vue